// extracted by mini-css-extract-plugin
export default {"adContainer":"styles_adContainer__uI58E","storeButtons":"styles_storeButtons__uMOpE","buttonLink":"styles_buttonLink__CZTvJ"};